import { render, staticRenderFns } from "./StockSourceList.vue?vue&type=template&id=2004879d&scoped=true"
import script from "./StockSourceList.vue?vue&type=script&lang=js"
export * from "./StockSourceList.vue?vue&type=script&lang=js"
import style0 from "./StockSourceList.vue?vue&type=style&index=0&id=2004879d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2004879d",
  null
  
)

export default component.exports